import { VendorTile } from "../VendorTile";
import { Loader } from "../Loader";
import { vendorResultStyle } from "../../helpers";
import { Fragment } from "preact";

import style from "./VendorsData.css";

const VendorsData = ({
  loading,
  pageVendors,
  totalVendorsCount,
  interestingVendors,
  showMap,
  onFavouriteVendor,
}) => {
  const topVendors = [];
  const basicVendors = [];
  pageVendors.forEach(vendor => {
    // VIP Vendors are just basic vendors that should appear before
    // all other basic vendors, this is why we are unshifting them
    if (vendor.isTop) {
      topVendors.push(vendor);
    } else if (vendor.isVip) {
      basicVendors.unshift(vendor);
    } else {
      basicVendors.push(vendor);
    }
  })

  const isHorizontal = showMap;
  if (loading) return <Loader />;

  const renderBasicVendors = () => {
    if (!basicVendors.length) return null;

    return (
      <div class={vendorResultStyle(showMap)}>
        {basicVendors.map((vendor) => (
          <VendorTile
            key={vendor.id}
            isHorizontal={isHorizontal}
            vendor={vendor}
            onFavouriteVendor={onFavouriteVendor}
            tileId={vendor.id}
          />
        ))}
      </div>
    );
  };

  const renderTopVendors = () => {
    if (!topVendors.length) return null;

    return (
      <div class={vendorResultStyle(showMap)}>
        {topVendors.map((vendor) => (
          <VendorTile
            key={vendor.id}
            isHorizontal={isHorizontal}
            vendor={vendor}
            onFavouriteVendor={onFavouriteVendor}
            tileId={vendor.id}
          />
        ))}
      </div>
    );
  };

  const conditionalBasicVendorHeader = () =>
    topVendors.length && basicVendors.length ? (
      <h3 class={style.otherVendors}>Weitere Dienstleister</h3>
    ) : null;

  const conditionalTopVendorHeader = () =>
    topVendors.length && basicVendors.length ? (
      <h3 class={style.topVendors}>Top Dienstleister</h3>
    ) : null;

  const renderLimitedResultsInfo = () => {
    if (totalVendorsCount < 5) {
      return (
        <h5 class={style.changeCriteria}>
          Versucht, eure Suchkriterien zu ändern. Folgende Anbieter konnten
          deine Kriterien nicht vollständig erfüllen
        </h5>
      );
    }
  };

  const renderInterestingVendors = () => {
    if (interestingVendors.length > 9)
      interestingVendors = interestingVendors.slice(0, 8);

    if (totalVendorsCount < 5 && interestingVendors.length > 0) {
      return (
        <Fragment>
          <h3 class={style.similarVendors}>
            Diese Anbieter könnten Dir auch gefallen:
          </h3>
          <div class={vendorResultStyle(showMap)}>
            {interestingVendors.map((vendor) => (
              <VendorTile
                key={vendor.id}
                isHorizontal={false}
                vendor={vendor}
                onFavouriteVendor={onFavouriteVendor}
                tileId={vendor.id}
            />
            ))}
          </div>
        </Fragment>
      );
    }
  };

  if (isHorizontal) {
    return (
      <div id="horizontalVendorsContainer" class={style.vendorsDataContainer}>
        {topVendors.map(vendor => (
          <VendorTile
            key={vendor.id}
            isHorizontal={isHorizontal}
            vendor={vendor}
            onFavouriteVendor={onFavouriteVendor}
            tileId={vendor.id}
          />
        ))}
        {basicVendors.map((vendor) => (
          <VendorTile
            key={vendor.id}
            isHorizontal={isHorizontal}
            vendor={vendor}
            onFavouriteVendor={onFavouriteVendor}
            tileId={vendor.id}
          />
        ))}
      </div>
    );
  }
  return (
    <Fragment>
      {conditionalTopVendorHeader()}
      {renderTopVendors()}
      {conditionalBasicVendorHeader()}
      {renderBasicVendors()}
      {renderLimitedResultsInfo()}
      {renderInterestingVendors()}
    </Fragment>
  );
};

export { VendorsData };
